"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _core = require("@linaria/core");
var _commonStyles = require("../styles/commonStyles");
var _useWindowSize = _interopRequireDefault(require("../hooks/useWindowSize.js"));
var _useLocalization = _interopRequireDefault(require("../hooks/useLocalization.js"));
var _spinner = _interopRequireDefault(require("@ux/spinner"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const animatedSectionStyles = "a1oen4hv";
const textLoopAnimationStyles = "t1hmobqe";
const spinnerStyles = "su8gz0i";
const cardAnimationStyles = "c1asxurn";

/**
 * Displays a text loop with a multi-layout skeleton. The card skeleton only displays on desktop.
 *
 * @param {string} props.market The market/locale code to retrieve translations
 * @returns {*} marquee skeleleton component
 */
function RecoreMarqueeSkeletonMultiLayout(_ref) {
  let {
    market
  } = _ref;
  const [flexLayout, setFlexLayout] = (0, _react.useState)(['50%', '25%', '25%', '0%']);
  const [currentText, setCurrentText] = (0, _react.useState)(0);
  const localizedHeadlines = (0, _useLocalization.default)(market);
  const textArray = localizedHeadlines('recore.marquee.skeleton.multilayout.headlines').split('|').map(word => word.trim());
  const {
    width
  } = (0, _useWindowSize.default)();
  const isMobile = width <= 520; // should match with breakpoint in css;

  (0, _react.useEffect)(() => {
    const layouts = [['50%', '50%', '0%', '0%'], ['25%', '25%', '25%', '25%'], ['50%', '25%', '25%', '0%']];
    let currentLayout = 0;
    const interval = setInterval(() => {
      if (!isMobile) {
        setFlexLayout(layouts[currentLayout]);
        currentLayout = (currentLayout + 1) % layouts.length;
      }
      setCurrentText(prevCurrentText => (prevCurrentText + 1) % textArray.length);
    }, 1500);
    return () => {
      clearInterval(interval);
    };
  }, [isMobile, textArray.length]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _core.cx)(animatedSectionStyles),
    "data-testid": "skeleton-container"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _core.cx)(textLoopAnimationStyles)
  }, textArray.map((text, index) => /*#__PURE__*/_react.default.createElement("div", {
    key: index,
    className: (0, _core.cx)('text-item', index === currentText && 'text-item-active')
  }, /*#__PURE__*/_react.default.createElement("h2", null, text)))), !isMobile && /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _core.cx)(cardAnimationStyles),
    "data-testid": "card-wrapper"
  }, flexLayout.map((basis, index) => /*#__PURE__*/_react.default.createElement("div", {
    key: index,
    className: (0, _core.cx)('flex-item'),
    style: {
      flexBasis: basis,
      opacity: basis !== '0%' ? 1 : 0
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _core.cx)('flex-item-inner')
  })))), isMobile && /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _core.cx)(spinnerStyles)
  }, /*#__PURE__*/_react.default.createElement(_spinner.default, {
    size: "md"
  })));
}
var _default = RecoreMarqueeSkeletonMultiLayout;
exports.default = _default;
RecoreMarqueeSkeletonMultiLayout.propTypes = {
  market: _propTypes.default.string
};